<template>
  <div>
    <v-snackbar v-model="showSnackBar" bottom right color="#63028F">
      {{msg}}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="showSnackBar = false">
          <v-icon size="15" color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-layout wrap justify-start v-if="loadImages">
      <v-flex px-2 xs3 md1 hidden-sm-and-down>
        <v-layout v-for="(item,i) in productData.photos" :key="i" wrap>
          <v-flex py-2 px-6 xs12>
            <v-card @click="showImage(item)" flat tile outlined>
              <v-layout wrap justify-center>
                <v-flex pa-2>
                  <v-img :src="baseURL +'/u/'+ item" height="60px" contain></v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex px-2 xs12 md5>
        <v-card flat tile outlined  height="400px">
          <v-layout wrap justify-center color="#E7E7E7">
            <v-flex pa-2 align-self-center>
              <v-img :src="baseURL+'/u/'+curImage" height="380px" contain></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex py-2 v-for="(item,i) in productData.photos" :key="i" px-2 xs3 md1 hidden-sm-and-up>
        <v-card @click="showImage(item)" flat tile outlined>
          <v-layout wrap justify-center>
            <v-flex pa-2>
              <v-img :src="baseURL +'/u/'+ item" height="60px" contain></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex px-2 md5 text-left>
        <v-layout wrap justify-start>
          <v-flex xs12 text-left>
            <span
              style="font-family:opensansbold;font-size:20px;color:#000000;"
              class="text-capitalize"
            >{{productData.productname}}</span>
          </v-flex>
          <v-flex xs12 text-left>
            <v-layout wrap>
              <v-flex xs3 sm3 md2 text-left>
                <span v-for="(item) in 5" :key="item">
                  <!-- <v-icon color="#FFC107" size="16px">mdi-star</v-icon> -->
                  <v-icon color="#C6C6C6" size="16px">mdi-star</v-icon>
                </span>
              </v-flex>
              <v-flex xs3 text-left>
                <span
                  style="font-family:opensansregular;font-size:12px;color:#292929;"
                  class="text-capitalize"
                >Not Rated</span>
              </v-flex>
              <v-flex text-right>
                <span
                  style="font-family:opensansregular;font-size:14px;color:#2DD986;"
                  class="text-capitalize"
                  v-if="productData.instock"
                >In Stock</span>
                <span
                  style="font-family:opensansregular;font-size:14px;color:#D90429;"
                  class="text-capitalize"
                  v-else
                >Out of Stock</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 pt-2 text-left>
            <span
              style="font-family:opensanssemibold;font-size:18px;color:#616161;"
              class="text-capitalize"
              v-if="productData.offer>0"
            >
              <s>MRP: ₹ {{productData.mrp}}</s>
            </span>
          </v-flex>
          <v-flex xs12 text-left>
            <span
              style="font-family:opensansbold;font-size:22px;color:#000000;"
              class="text-capitalize"
            >Price: ₹ {{productData.price}}</span>
          </v-flex>
          <v-flex xs12 text-left>
            <span
              style="font-family:opensansregular;font-size:14px;color:#616161;"
              class="text-capitalize"
            >Inclusive of all taxes</span>
          </v-flex>
          <v-flex xs12 text-left>
            <span
              style="font-family:opensansregular;font-size:14px;color:#2DD986;"
              class="text-capitalize"
              v-if="productData.savedamount>0"
            >
              <i>You Save: ₹{{productData.savedamount}}</i>
            </span>
          </v-flex>
          <v-flex v-if="appPincode" pt-4 xs12 text-left>
            <span
              style="font-family:opensansregular;font-size:14px;color:#2DD986;"
              v-if="deliverable"
            >
              <i>Product can be delivered to</i>
              {{pincode}}
            </span>
            <span style="font-family:opensansregular;font-size:14px;color:#D90429;" v-else>
              <i>Product can't be delivered to</i>
              {{pincode}}
            </span>
          </v-flex>
          <v-flex xs12 pt-2 text-left>
            <span
              style="font-family:opensansregular;font-size:16px;color:#000000;"
              class="text-capitalize"
            >Shipping Charge: ₹0</span>
          </v-flex>
          <v-flex v-if="productData.instock" xs6 md2 pt-4 text-left>
            <v-select
              :items="quantities"
              v-model="productQuantity"
              dense
              solo
              color="#63028F"
              item-color="#63028F"
            >
              <template v-slot:selection>
                <span
                  style="font-family:opensansbold;font-size:13px;color:#2A2A2A;"
                  class="text-capitalize"
                >Qty: {{productQuantity}}</span>
              </template>
            </v-select>
          </v-flex>
          <v-flex v-if="productData.instock" xs6 md4 lg4 xl3 pt-4 px-2 text-left>
            <v-btn medium block dark depressed :ripple="false" color="#63028F" @click="addToCart()">
              <v-icon size="15">mdi-cart</v-icon>
              <span
                style="font-family:opensansregular;font-size:14px;"
                class="text-capitalize"
              >Add to Cart</span>
            </v-btn>
          </v-flex>
          <v-flex v-if="productData.instock" xs6 md4 lg4 xl3 pt-4 px-2 text-left>
            <v-btn
              medium
              block
              dark
              depressed
              :ripple="false"
              color="#63028F"
              :to="'/BuyNow/'+productData._id"
            >
              <v-icon size="15">mdi-cart</v-icon>
              <span
                style="font-family:opensansregular;font-size:14px;"
                class="text-capitalize"
              >Buy Now</span>
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <span
              style="font-family:opensanssemibold;font-size:14px;color:#63028F;cursor:pointer"
              @click="addToWishList"
            >Add to Wishlist</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex py-7></v-flex>
        </v-layout>
        <!-- <v-layout pt-4 wrap>
          <v-flex xs12>
            <v-card outlined class="rounded-pill">
              <v-layout wrap>
                <v-flex xs12 text-center>
                  <span
                    style="font-family:opensanssemibold;font-size:14px;color:#CB4444;"
                    class="text-capitalize pa-2 py-2"
                  >Paytm - Upto min. 200 cashback* on min transaction of ₹300/: T&C apply.</span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex pt-2>
            <v-card outlined class="rounded-pill">
              <v-layout wrap>
                <v-flex xs12 text-center>
                  <span
                    style="font-family:opensanssemibold;font-size:14px;color:#CB4444;"
                    class="text-capitalize pa-2 py-2"
                  >Phonepay: Upto min. 100 cashback* on min transaction of ₹300/: T&C apply.</span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>-->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
export default {
  props: ["productData"],
  data() {
    return {
      quantities: [],
      productQuantity: 1,
      showSnackBar: false,
      loadImages: false,
      curImage: null,
      msg: null,
      deliverable: false,
      pincode: localStorage.getItem("pincode"),
      enableOrder: false,
    };
  },
  computed: {
    appPincode() {
      var vm = this;
      vm.pincode = store.state.pincode;
      this.getDelivery();
      return store.state.pincode;
    },
  },
  beforeMount() {
    this.curImage = this.productData.photos[0];
    if (this.productData.photos.length > 2) {
      this.productData.photos.slice(0, 2);
      this.loadImages = true;
    } else {
      this.loadImages = true;
    }
    for (var i = 1; i <= this.productData.stockquantity; i++) {
      this.quantities.push(i);
    }
  },
  methods: {
    getDelivery() {
      axios({
        method: "GET",
        url: "/product/checkpincode",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          pincode: localStorage.getItem("pincode"),
          productid: this.productData._id,
        },
      })
        .then((response) => {
          this.deliverable = response.data.status;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showImage(item) {
      this.curImage = item;
    },
    addToCart() {
      if (!store.state.isLoggedIn) {
        this.$router.push("/Login");
        return;
      }
      var cart = {};
      cart["productid"] = this.productData._id;
      cart["quantity"] = this.productQuantity;
      axios({
        method: "POST",
        url: "/Cart/Addorupdate",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            store.commit("changeCart", response.data.count);
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addToWishList() {
      var wishlist = {};
      wishlist["productid"] = this.productData._id;
      axios({
        method: "POST",
        url: "/WishList/Add",
        data: wishlist,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>